import { createStore, applyMiddleware } from 'redux';
import { createSession } from 'redux-session';
import promise from 'redux-promise-middleware';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import reducer from './reducers';

var storedSession = {};
const session = createSession({
	ns: 'skrutiner-registration',
	selectState (state) {
		return {
			session: state.session
		}
	},
	onLoad(state, dispatch) {
		// Dispatching while constructing middleware is not allowed
		storedSession = state;
	}	
});

const store = createStore(reducer, applyMiddleware(session, promise(), thunk, logger));

store.dispatch({type: "LOAD_SESSION", value: storedSession});

export default store;


// WEBPACK FOOTER //
// ./src/store.js